import React from 'react'
import Typography from 'components/atoms/_layouts/Typography'
import styled from 'styled-components'
import I18n from 'core/i18n'
import SVG from 'react-inlinesvg'
import * as constants from 'static/constants'
import { IWindow, IIncludedItem } from 'static/interfaces'
import SvgIcon from 'components/atoms/SvgIcon'

declare var window: IWindow
interface IProps {
  includedItems: IIncludedItem[]
}

export const PostIncludedModalBody: React.FC<IProps> = ({ includedItems }) => (
  <ModalBody>
    <div className="header">
      <Typography type="headline" size="lg">
        {I18n.t('post.included')}
      </Typography>
      <button
        className="closeButton"
        onClick={() => window.globalModal.closeModal()}
        type="button"
        aria-label="Close This Window"
      >
        <SVG src="/images/icons/close.svg" className="icon" aria-hidden="true" />
      </button>
    </div>
    <div className="items">
      {includedItems.map((item, index) => {
        return (
          <div className="item" key={index}>
            <div className="title">
              <SvgIcon name={item.type} className="icon" ariaHidden={true} role="presentation" />
              <Typography type="headline" size="md" color="primary">
                {I18n.t(`post.included_category_${item.type}`)}
              </Typography>
            </div>
            <div className="description">{item.description}</div>
          </div>
        )
      })}
    </div>
  </ModalBody>
)

const ModalBody = styled.div`
  .header {
    text-align: center;
    padding: 24px;
    @media screen and (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      .headline {
        font-size: 20px;
      }
    }
  }

  .closeButton {
    position: absolute;
    right: 2.4rem;
    top: 2.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3.2rem;
    height: 3.2rem;
    padding: 0;
    color: ${constants.COLORS.black};
    border: 1px solid ${constants.COLORS.divider2};
    border-radius: 50%;
    background-color: ${constants.COLORS.white};
    cursor: pointer;
    transition: border-color 0.2s, background-color 0.2s, color 0.2s;
    z-index: 999;
    @media screen and (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      right: 1.6rem;
      top: 1.6rem;
    }
    svg {
      width: 2rem;
    }
    &:hover {
      color: ${constants.COLORS.white};
      background-color: ${constants.COLORS.primary};
      border-color: ${constants.COLORS.primary};
    }
  }
  .items {
    display: flex;
    max-height: calc(80dvh - 90px);
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0 24px;
    @media screen and (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      max-height: calc(100dvh - 78px);
    }

    .item {
      padding: 24px 0;
      .title {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        gap: 12px;
        .icon {
          flex-shrink: 0;
          width: 40px;
          height: 40px;
        }
      }
      &:first-child {
        padding-top: 0;
      }
      &:last-child {
        padding-bottom: 40px;
      }
      &:not(:last-child) {
        border-bottom: 1px solid ${constants.COLORS.divider};
      }
      .description {
        font-size: 14px;
        word-break: break-word;
        white-space: pre-wrap;
      }
    }
  }
`
